export default "__VITE_ASSET__DzXdL8Di__"